import { Injectable } from '@angular/core';

import { URL } from '@app-shared/constants/service-urls';
import { ApiService } from '@app-shared/services/api.service';
import { APIRequest } from '@app-shared/services/req-res.types';
import { UtilService } from '@app-shared/services/util.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LeadService {
  constructor(private api: ApiService, private util: UtilService) { }

  get orgID(): string | null {
    const value = localStorage.getItem('OrgId');
    if (value) {
      return this.util.decrypt(value);
    }
    return null;
  }

  updateReasonForDropping(data: any) {
    const postData: APIRequest = {
      requestBody: {
        ...data,
      },
    };

    return this.api.post(URL.SALES.UPDATE_REASON_FOR_DROPPING, postData);
  }

  uploadSalesLeadsData(data: any) {
    const postData: APIRequest = {
      requestBody: {
        ...data,
      },
    };

    return this.api.post(URL.SALES.UPLOAD_SALES_LEADS_DATA, postData);
  }
  

getAllContentLabels(courseId: number, versionId: number): Observable<any> {
  const postData: APIRequest = {
    requestBody: {
      courseId: courseId,
      versionId: versionId
    }
  };
  return this.api.post(`${URL.CONTENT.CONTENT_LABEL}/getAll`, postData);
}


// Get single content label by id
getContentLabelById(id: number): Observable<any> {
  const postData: APIRequest = {
    requestBody: {
      labelId: id
    }
  };
  return this.api.post(`${URL.CONTENT.CONTENT_LABEL}/getById`, postData);
}


  // Add or Edit content label
  addOrEditContentLabel(data: any, id?: number): Observable<any> {
    const postData: APIRequest = {
      requestBody: {
        ...data,
      },
    };

   if (id) {
  return this.api.put(`${URL.CONTENT.CONTENT_LABEL}/${id}`, postData);
}
return this.api.post(URL.CONTENT.CONTENT_LABEL, postData);

  }

  // Bulk create labels with hierarchy consolidation
  bulkCreateContentLabels(labels: any[]): Observable<any> {
    const postData: APIRequest = {
      requestBody: {
        labels: labels,
      },
    };
    return this.api.post(`${URL.CONTENT.CONTENT_LABEL}`, postData);
  }

  // Update specific content label by ID
  updateContentLabel(data: any): Observable<any> {
    const postData: APIRequest = {
      requestBody: {
        ...data,
      },
    };
    return this.api.put(`${URL.CONTENT.CONTENT_LABEL}/${data.labelId}`, postData);
  }
  bulkUpdateContentLabels(labels: any[]): Observable<any> {
    const postData: APIRequest = {
      requestBody: {
        labels: labels,
      },
    };
    return this.api.post(`${URL.CONTENT.CONTENT_LABEL}/bulkUpdate`, postData);
  }

  // Delete specific content label by ID (soft delete - marks as deleted)
  deleteContentLabel(data: any): Observable<any> {
    const postData: APIRequest = {
      requestBody: {
        ...data,
      },
    };
    return this.api.post(`${URL.CONTENT.CONTENT_LABEL}/${data.labelId}/delete`, postData);
  }

  getAllLeads() {
    return this.api.get(URL.SALES.LEADS);
  }
    getAllContacts() {
    return this.api.get(URL.SALES.CONTACT);
  }

  addOrEditSalesLead(data: any, id: any) {
    const postData: APIRequest = {
      requestBody: {
        ...data,
      },
    };
    if (id) {
      return this.api.put(`${URL.SALES.LEADS}/${id}`, postData);
    }
    return this.api.post(URL.SALES.LEADS, postData);
  }
  addOrEditSalesContact(data: any, id: any) {
    const postData: APIRequest = {
      requestBody: {
        ...data,
      },
    };
    if (id) {
      return this.api.put(`${URL.SALES.CONTACT}/${id}`, postData);
    }
    return this.api.post(URL.SALES.CONTACT, postData);
  }
  updateContactLeadIds(contactId: number, leadIds: number[]): Observable<any> {
  const postData: APIRequest = {
    requestBody: {
      leadIds: leadIds,
   //   organizationId: this.orgId
    }
  };
  
  return this.api.put(`${URL.SALES.CONTACT}/${contactId}/lead-ids`, postData);
}
  // New method to remove a specific lead from a contact
removeLeadFromContact(contactId: number, leadId: number): Observable<any> {
  const postData: APIRequest = {
    requestBody: {
      leadId: leadId,
      organizationId: this.orgID
    }
  };
  return this.api.put(`${URL.SALES.CONTACT}/${contactId}/remove-lead`, postData);
}

  getLead(id: any) {
    return this.api.get(`${URL.SALES.LEADS}/${id}`);

  }
  getContactsByLead(id:any){
        return this.api.get(`${URL.SALES.CONTACT}/${id}`);
  }
   checkExistingContact(name: string, emailId: string) {
    return this.api.get(`${URL.SALES.CONTACT}/check?name=${encodeURIComponent(name)}&emailId=${encodeURIComponent(emailId)}`);
  }
  

}